import React, { useState, useEffect, useRef, useCallback } from "react";
import { useQuery } from "react-query";
import "cropperjs/dist/cropper.css";
import "./Calender.css";
import axios from "axios";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import { RRule } from 'rrule';
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Modal from "react-modal";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { reset as headerReset, setHeaderText } from "../../features/headerText/headerTextSlice.js";
import "react-tabs/style/react-tabs.css";
import { useUserProfiles } from "../User/userProfileQueries";
import { ThreeDots } from "react-loader-spinner";
import CustomTimeSlotsWrapper from "./CustomTimeSlotsWrapper.jsx";
import PlusIcon from "../../images/icons/plus-icon.svg";
import ArrowIcon from "../../images/icons/arrow-bottom-white.svg";
import ViewCalendarEventModal from "./ViewCalendarEventModal.jsx";
import CreateEventModal from "./CreateEventModal.jsx";
import GoogleTokenInvalidModal from "./GoogleTokenInvalidModal.jsx";
import MicrosoftTokenInvalidModal from "./MicrosoftTokenInvalidModal.jsx";
import { CATEGORYLIST, checkGoogleCalendarEnabledStatus, checkGoogleCalendarIntegration, checkMicrosoftCalendarEnabledStatus, checkMicrosoftCalendarIntegration, checkMicrosoftTokenValidity, checkTokenValidity, fetchEvents, fetchGoogleCalendarEvents, fetchLeaves, fetchMicrosoftCalendarEvents, groupEventsByKey, HOLIDAYS_2025, STATUS_COLORS } from "./services.js";
import { debounce } from "lodash";
// Mock constants (replace with actual imports/values)

const SUPER_ADMIN = 1;
const ADMIN = 2;
const USER = 3;
const PROJECT_MANAGER = 6;
const TEAM_MANAGER = 7;

Modal.setAppElement("#root");

const Calender = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const localizer = momentLocalizer(moment);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [createEventModalOpen, setCreateEventModalOpen] = useState(false);
    const [isSlotSelected, setIsSlotSelected] = useState(false);
    const [selectedEvents, setSelectedEvents] = useState([]);
    const [clickedDate, setClickedDate] = useState(null);
    const [filter, setFilter] = useState("");
    const [view, setView] = useState('month');
    const [expandedEventIndex, setExpandedEventIndex] = useState(null);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [dateRange, setDateRange] = useState([null, null]);
    const [dateRangeType, setDateRangeType] = useState("multiple");
    const [dateRangeIsValid, setDateRangeIsValid] = useState(false);
    const [startTime, setStartTime] = useState("");
    const [startTimeIsValid, setStartTimeIsValid] = useState(false);
    const [endTime, setEndTime] = useState("");
    const [endTimeIsValid, setEndTimeIsValid] = useState(false);
    const [eventName, setEventName] = useState("");
    const [eventDescription, setEventDescription] = useState("");
    const [eventLocation, setEventLocation] = useState("");
    const [eventOrganizer, setEventOrganizer] = useState("");
    const [eventAttendees, setEventAttendees] = useState([]);
    const [eventBannerFile, setEventBannerFile] = useState(null);
    const [eventBanner, setEventBanner] = useState(null);
    const [isVirtual, setIsVirtual] = useState(false);
    const [eventMeetingLink, setEventMeetingLink] = useState("");
    const [repeatType, setRepeatType] = useState("does_not_repeat");
    const [repeatTypeDropdownOpen, setRepeatTypeDropdownOpen] = useState(false);
    const [repeatTypeIsValid, setRepeatTypeIsValid] = useState(false);
    const [eventStartTime, setEventStartTime] = useState("");
    const [eventEndTime, setEventEndTime] = useState("");
    const [startTimeString, setStartTimeString] = useState(moment(eventStartTime).format("HH:mm"));
    const [endTimeString, setEndTimeString] = useState(moment(eventEndTime).format("HH:mm"));
    const [eventNameIsValid, setEventNameIsValid] = useState(false);
    const [eventDate, setEventDate] = useState(null);
    const [eventDateIsValid, setEventDateIsValid] = useState(false);
    const [eventStartTimeIsValid, setEventStartTimeIsValid] = useState(false);
    const [eventEndTimeIsValid, setEventEndTimeIsValid] = useState(false);
    const [organizerDropdownOpen, setOrganizerDropdownOpen] = useState(false);
    const [selectedEventForEdit, setSelectedEventForEdit] = useState(null);
    const [isGoogleSyncVisible, setIsGoogleSyncVisible] = useState(false);
    const [isMicrosoftSyncVisible, setIsMicrosoftSyncVisible] = useState(false);
    const [reminderMethod, setReminderMethod] = useState('popup');
    const [reminderMethodDropdownOpen, setReminderMethodDropdownOpen] = useState(false);
    const [reminderMinutes, setReminderMinutes] = useState(10);
    const [reminderMinutesIsValid, setReminderMinutesIsValid] = useState(false);
    const [isMicrosoftTokenChecking, setIsMicrosoftTokenChecking] = useState(false);
    const [isMicrosoftTokenInvalidModalOpen, setIsMicrosoftTokenInvalidModalOpen] = useState(false);
    const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
    const [googleMicrosoftUserSearchTerm, setGoogleMicrosoftUserSearchTerm] = useState('');
    const [selectAllUsers, setSelectAllUsers] = useState(false);
    const userDropdownRef = useRef(null);
    const [isGoogleTokenInvalidModalOpen, setIsGoogleTokenInvalidModalOpen] = useState(false);
    const [isGoogleTokenChecking, setIsTokenChecking] = useState(false);
    const [isCategoryLoading, setIsCategoryLoading] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const createDropdownRef = useRef();
    const [externalAttendees, setExternalAttendees] = useState([]);
    const dummyImage = "/Uploads/lowProfileImage/user_default.png";
    const { user } = useSelector((state) => state.auth);
    const token = useSelector((state) => state.auth.token);
    const { appSettings } = useSelector((state) => state.appSettings);
    const [selectedUsers, setSelectedUsers] = useState(user?._id ? [user._id] : []);
    const [selectedCategories, setSelectedCategories] = useState(CATEGORYLIST.map(c => c.name));
    const [isUserLoading, setIsUserLoading] = useState(false);

    const { data: leaves, isLoading: leavesLoading, error: leavesError, refetch: refetchLeaves } = useQuery(
        ["leaves", token],
        () => fetchLeaves(token),
        { enabled: !!token }
    );

    const { data: eventsData, isLoading: eventsLoading, error: eventsError, refetch: refetchEvents } = useQuery(
        ["events", token],
        () => fetchEvents(token),
        { enabled: !!token }
    );

    const { data: userProfiles = [], isLoading: userProfileLoading } = useUserProfiles(token);
    const { data: calendarUsers = [], isLoading: calendarUsersLoading } = useQuery(
        ['calendarUsers', token],
        async () => {
            const response = await axios.get('/api/calendar/users', {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        },
        { enabled: !!token }
    );

    const { data: selectedGoogleEvents = [], isLoading: selectedGoogleEventsLoading, error: selectedGoogleEventsError, refetch: refetchSelectedGoogleEvents } = useQuery(
        ["selectedGoogleEvents", token, selectedUsers],
        () => fetchGoogleCalendarEvents(token, selectedUsers, setIsGoogleTokenInvalidModalOpen),
        {
            enabled: !!token && selectedUsers.length > 0 && !!user?._id && !!user?.email,
            retry: 1,
            onSuccess: (data) => {
                if (data.some((result) => result.events.length > 0)) {
                    setIsGoogleTokenInvalidModalOpen(false);
                }
            },
        }
    );

    const { data: selectedMicrosoftEvents = [], isLoading: selectedMicrosoftEventsLoading, error: selectedMicrosoftEventsError, refetch: refetchSelectedMicrosoftEvents } = useQuery(
        ["selectedMicrosoftEvents", token, selectedUsers],
        () => fetchMicrosoftCalendarEvents(token, selectedUsers, setIsMicrosoftTokenInvalidModalOpen),
        {
            enabled: !!token && selectedUsers.length > 0 && !!user?._id && !!user?.email,
            retry: 1,
            onSuccess: (data) => {
                if (data.some((result) => result.events.length > 0)) {
                    setIsMicrosoftTokenInvalidModalOpen(false);
                }
            },
        }
    );

    const uniqueBirthdays = new Set();
    const uniqueAnniversaries = new Set();
    const uniqueHolidays = new Set();

    useEffect(() => {
        const checkCalendarSyncConditions = async () => {
            try {
                const isMicrosoftCalendarEnabled = await checkMicrosoftCalendarEnabledStatus(token, user._id);
                const isMicrosoftTokenValid = await checkMicrosoftTokenValidity(token, user, setIsMicrosoftTokenChecking);
                const isMicrosoftIntegrated = await checkMicrosoftCalendarIntegration(token, user.email);
                setIsMicrosoftSyncVisible(isMicrosoftCalendarEnabled && isMicrosoftTokenValid && isMicrosoftIntegrated);

                const isGoogleCalendarEnabled = await checkGoogleCalendarEnabledStatus(token, user._id);
                const isGoogleTokenValid = await checkTokenValidity(token, user, setIsTokenChecking);
                const isGoogleIntegrated = await checkGoogleCalendarIntegration(token, user.email);
                setIsGoogleSyncVisible(isGoogleCalendarEnabled && isGoogleTokenValid && isGoogleIntegrated);
            } catch (error) {
                console.error('Error checking calendar conditions:', error);
                setIsMicrosoftSyncVisible(false);
                setIsGoogleSyncVisible(false);
            }
        };

        checkCalendarSyncConditions();
    }, [token, user._id, user.email, setIsMicrosoftTokenChecking, setIsTokenChecking]);

    useEffect(() => {
        if (calendarUsers.length === 0) return;
        const allUserIds = calendarUsers.map((user) => user.userId).sort().toString();
        const selectedUserIds = selectedUsers.slice().sort().toString();
        setSelectAllUsers(allUserIds === selectedUserIds);
    }, [selectedUsers, calendarUsers]);

    const timeList = Array.from({ length: 24 }, (_, i) => {
        const hour12 = new Date(0, 0, 0, i).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });

        return {
            time: hour12,
            time_value: i, // Numeric value from 0 to 23
        };
    });

    const toggleDropdown = () => setIsOpen(!isOpen);

    const events = [];
    if (leaves) {
        leaves.forEach((leave) => {
            const fullName = leave.user?.first_name
                ? `${leave.user.first_name} ${leave.user.middle_name && leave.user.middle_name !== "null" ? leave.user.middle_name + " " : ""}${leave.user.last_name || ""}`.trim()
                : leave.user?.company_first_name
                    ? `${leave.user.company_first_name} ${leave.user.company_last_name || ""}`.trim()
                    : `${leave.user?.company_name || ""} (Company)`;

            const startDate = new Date(leave.start_date);
            const endDate = new Date(leave.end_date);
            const totalDays = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
            const issueDate = new Date(leave.created_at);

            let eventStart = moment.tz(startDate, global.config.getTimeZone()).toDate();
            let eventEnd = moment.tz(new Date(endDate).setDate(endDate.getDate()), global.config.getTimeZone()).toDate();
            const hasTime = leave.start_time != null && leave.end_time != null;

            if (hasTime) {
                // Use numeric start_time and end_time as hours
                eventStart = moment.tz(leave.start_date, global.config.getTimeZone())
                    .set({
                        hour: parseInt(leave.start_time, 10),
                        minute: 0,
                        second: 0,
                    })
                    .toDate();

                eventEnd = moment.tz(leave.end_date, global.config.getTimeZone())
                    .set({
                        hour: parseInt(leave.end_time, 10),
                        minute: 0,
                        second: 0,
                    })
                    .toDate();
            }

            events.push({
                // title: `${fullName} - ${leave.type_of_leave.leave_type}${totalDays > 1 ? ` (${totalDays} days)` : ""}`,
                title: `${(user.userType === SUPER_ADMIN || user.userType === ADMIN || user.userType === PROJECT_MANAGER) ? `${fullName} - ` : ""
                    }${leave.type_of_leave.leave_type}${totalDays > 1 ? ` (${totalDays} days)` : ""}`,
                start: eventStart,
                end: eventEnd,
                backgroundColor: STATUS_COLORS[leave.status]?.backgroundColor || "#95a5a6",
                color: STATUS_COLORS[leave.status]?.color || "#FFFFFF",
                borderColor: STATUS_COLORS[leave.status]?.borderColor || "#FFFFFF",
                profileImage: leave.user?.profile_image ? `/Uploads/lowProfileImage/${leave.user.profile_image}` : dummyImage,
                description: leave.note,
                status: leave.status,
                user: fullName,
                typeOfLeave: leave.type_of_leave.leave_type,
                issueDate: issueDate,
                totalDays: totalDays,
                startDate: new Date(leave.start_date).toLocaleDateString("en-US"),
                endDate: new Date(leave.end_date).toLocaleDateString("en-US"),
                startTime: leave.start_time || null,
                endTime: leave.end_time || null,
                note: leave.note,
                leaveId: leave._id,
                eventType: "Leave",
                allDay: !hasTime, // Set allDay to false if times are specified
            });
        });
    }

    if (eventsData) {
        eventsData.forEach((event) => {
            const hasMatchingAttendee = event.event_attendees?.some((attendee) =>
                selectedUsers.includes(attendee.user?._id?.toString())
            );
            // console.log("event", event);
            if (selectedUsers.length === 0 || hasMatchingAttendee) {
                const organizerName = event.event_organizer?.first_name
                    ? `${event.event_organizer.first_name} ${event.event_organizer.last_name || ""}`.trim()
                    : event.event_organizer?.company_name || "Unknown Organizer";

                let eventStart = moment.tz(event.event_date, global.config.getTimeZone()).toDate();
                let eventEnd = moment.tz(event.event_date, global.config.getTimeZone()).toDate();
                const hasTime = event.start_date_time != null && event.end_date_time != null;

                if (hasTime) {
                    eventStart = moment.tz(event.event_date, global.config.getTimeZone())
                        .set({
                            hour: moment(event.start_date_time).hour(),
                            minute: moment(event.start_date_time).minute(),
                            second: 0,
                        })
                        .toDate();

                    eventEnd = moment.tz(event.event_date, global.config.getTimeZone())
                        .set({
                            hour: moment(event.end_date_time).hour(),
                            minute: moment(event.end_date_time).minute(),
                            second: 0,
                        })
                        .toDate();
                }

                events.push({
                    title: event.event_name,
                    start: eventStart,
                    end: eventEnd,
                    backgroundColor: STATUS_COLORS.Event.backgroundColor,
                    borderColor: STATUS_COLORS.Event.borderColor,
                    color: STATUS_COLORS.Event.color,
                    profileImage: event.event_organizer?.profile_image ? `/Uploads/lowProfileImage/${event.event_organizer.profile_image}` : dummyImage,
                    description: event.event_description || "No description",
                    eventType: "Event",
                    allDay: !hasTime,
                    eventName: event.event_name,
                    eventLocation: event.event_location || "No location",
                    eventOrganizer: organizerName,
                    eventOrganizerId: event.event_organizer?._id || user._id,
                    // eventAttendees: event.event_attendees || [],
                    eventAttendees: event.event_attendees ? event.event_attendees.map(attendee => ({
                        user: {
                            _id: attendee.user?._id || attendee.user,
                            firstName: attendee.user?.first_name || "",
                            lastName: attendee.user?.last_name || "",
                            middleName: attendee.user?.middle_name || "",
                            companyName: attendee.user?.company_name || "",
                            companyFirstName: attendee.user?.company_first_name || "",
                            companyLastName: attendee.user?.company_last_name || "",
                            email: attendee.user?.email || "",
                            // profileImage: attendee.user?.profile_image ? `/Uploads/lowProfileImage/${attendee.user.profile_image}` : dummyImage,
                            profileImage: attendee.user?.profile_image ? attendee.user.profile_image : dummyImage,
                        },
                        status: attendee.status || "pending",
                        reason: attendee.reason || null,
                        responseDate: attendee.response_date ? moment(attendee.response_date).format("YYYY-MM-DD HH:mm") : null,
                        additionalNotes: attendee.additional_notes || null,
                    })) : [],
                    externalAttendees: event.external_attendees ? event.external_attendees.map(attendee => ({
                        email: attendee.email || "",
                        name: attendee.name || "",
                        status: attendee.status || "pending",
                        reason: attendee.reason || null,
                        responseDate: attendee.response_date ? moment(attendee.response_date).format("YYYY-MM-DD HH:mm") : null,
                        additionalNotes: attendee.additional_notes || null,
                    })) : [],
                    eventBanner: event.event_banner ? `/Uploads/${event.event_banner}` : null,
                    eventIsVirtual: event.event_is_virtual,
                    eventMeetingLink: event.event_meeting_link || null,
                    repeatType: event.repeat_type,
                    startTime: event.start_date_time ? moment(event.start_date_time).format("HH:mm") : null,
                    endTime: event.end_date_time ? moment(event.end_date_time).format("HH:mm") : null,
                    startDate: new Date(event.event_date).toLocaleDateString("en-US"),
                    endDate: event.end_date_time ? new Date(event.end_date).toLocaleDateString("en-US") : null,
                    _id: event._id,
                });
            }
        });
    }

    if (userProfiles) {
        userProfiles.forEach((userProfile) => {
            const dob = userProfile.dob ? new Date(userProfile.dob) : null;
            const currentYear = new Date().getFullYear();
            const futureYears = 5; // Number of future years to include (2025 + 5 = 2030)

            if (!dob || isNaN(dob)) return; // Skip invalid or missing dob

            const fullName = userProfile.first_name
                ? `${userProfile.first_name} ${userProfile.middle_name && userProfile.middle_name !== "null" ? userProfile.middle_name + " " : ""}${userProfile.last_name || ""}`.trim()
                : userProfile.company_first_name
                    ? `${userProfile.company_first_name} ${userProfile.company_last_name || ""}`.trim()
                    : `${userProfile.company_name || ""} (Company)`;

            // Generate birthdays from birth year to future years
            const birthYear = dob.getFullYear();
            for (let year = birthYear; year <= currentYear + futureYears; year++) {
                const age = year - birthYear;
                const birthday = new Date(Date.UTC(year, dob.getMonth(), dob.getDate()));
                const birthdayInIST = moment.tz(birthday, global.config.getTimeZone()).format("YYYY-MM-DD");

                // Include all birthdays (from birth year onward)
                if (!uniqueBirthdays.has(`${birthdayInIST}-${fullName}`)) {
                    // const ageText = age === 1 ? "1st" : age === 2 ? "2nd" : age === 3 ? "3rd" : `${age}th`;
                    events.push({
                        title: `🎂 ${fullName}'s Birthday 🎉`,
                        date: birthdayInIST,
                        start: moment.tz(birthdayInIST, global.config.getTimeZone()).toDate(),
                        end: moment.tz(birthdayInIST, global.config.getTimeZone()).toDate(),
                        backgroundColor: STATUS_COLORS.Birthday.backgroundColor,
                        color: STATUS_COLORS.Birthday.color,
                        borderColor: STATUS_COLORS.Birthday.borderColor,
                        profileImage: userProfile.profile_image ? `/Uploads/lowProfileImage/${userProfile.profile_image}` : dummyImage,
                        description: `Celebrate ${fullName}'s birthday! 🎂🎁`,
                        eventType: "Birthday",
                        allDay: true,
                        age: age, // Optional: store age for future use
                    });
                    uniqueBirthdays.add(`${birthdayInIST}-${fullName}`);
                }
            }
        });

        userProfiles.forEach((userProfile) => {
            const joinedDate = userProfile.joinedDate ? new Date(userProfile.joinedDate) : null;
            const currentYear = new Date().getFullYear();
            const futureYears = 50; // Number of future years to include (adjust as needed)

            if (!joinedDate || isNaN(joinedDate)) return; // Skip invalid or missing joinedDate

            const fullName = userProfile.first_name
                ? `${userProfile.first_name} ${userProfile.middle_name && userProfile.middle_name !== "null" ? userProfile.middle_name + " " : ""}${userProfile.last_name || ""}`.trim()
                : userProfile.company_first_name
                    ? `${userProfile.company_first_name} ${userProfile.company_last_name || ""}`.trim()
                    : `${userProfile.company_name || ""} (Company)`;

            // Generate anniversaries from the first anniversary year to future years
            const joinedYear = joinedDate.getFullYear();
            for (let year = joinedYear + 1; year <= currentYear + futureYears; year++) {
                const yearsSinceJoined = year - joinedYear;
                const anniversary = new Date(Date.UTC(year, joinedDate.getMonth(), joinedDate.getDate()));
                const anniversaryInIST = moment.tz(anniversary, global.config.getTimeZone()).format("YYYY-MM-DD");

                // Only include anniversaries that are on or after the first anniversary
                if (yearsSinceJoined >= 1 && !uniqueAnniversaries.has(`${anniversaryInIST}-${fullName}`)) {
                    const yearText = yearsSinceJoined === 1 ? "1st" : yearsSinceJoined === 2 ? "2nd" : yearsSinceJoined === 3 ? "3rd" : `${yearsSinceJoined}th`;
                    events.push({
                        title: `🎁 ${fullName}'s ${yearText} Work Anniversary 🎉`,
                        date: anniversaryInIST,
                        start: moment.tz(anniversaryInIST, global.config.getTimeZone()).toDate(),
                        end: moment.tz(anniversaryInIST, global.config.getTimeZone()).toDate(),
                        backgroundColor: STATUS_COLORS.Anniversary.backgroundColor,
                        color: STATUS_COLORS.Anniversary.color,
                        borderColor: STATUS_COLORS.Anniversary.borderColor,
                        profileImage: userProfile.profile_image ? `/Uploads/lowProfileImage/${userProfile.profile_image}` : dummyImage,
                        description: `Celebrating ${fullName}'s ${yearText} work anniversary! 🎈`,
                        eventType: "Anniversary",
                        allDay: true,
                        years: yearsSinceJoined, // Optional: store years for future use
                    });
                    uniqueAnniversaries.add(`${anniversaryInIST}-${fullName}`);
                }
            }
        });
    }

    if (Array.isArray(selectedGoogleEvents) && selectedGoogleEvents.length > 0) {
        selectedGoogleEvents.forEach(({ events: userEvents, userId }) => {
            const calendarUser = calendarUsers.find((u) => u.userId === userId);
            const userName = calendarUser?.username || 'Unknown';

            userEvents.forEach((event) => {
                const start = event.start?.dateTime || event.start?.date;
                const end = event.end?.dateTime || event.end?.date;
                if (!start || !end) {
                    console.warn(`Skipping Google event for user ${userId}: Invalid start or end date`, event);
                    return;
                }

                // Normalize dates based on allDay
                const timezone = global.config.getTimeZone() || 'UTC';
                let startDate = moment.tz(start, timezone);
                let endDate = moment.tz(end, timezone);
                if (!event.start.dateTime) { // allDay event
                    startDate = startDate.startOf('day');
                    endDate = endDate.startOf('day');
                }

                events.push({
                    // title: `${userName} - ${event.summary || 'Google Calendar Event'}`,
                    title: userId === user._id ? (event.summary || 'Google Calendar Event') : `${userName} - ${event.summary || 'Google Calendar Event'}`,
                    start: startDate.toDate(),
                    end: endDate.toDate(),
                    backgroundColor: STATUS_COLORS.GoogleEvent.backgroundColor,
                    color: STATUS_COLORS.GoogleEvent.color,
                    borderColor: STATUS_COLORS.GoogleEvent.borderColor,
                    profileImage: calendarUser?.photoImage ? `/Uploads/lowProfileImage/${calendarUser.photoImage}` : dummyImage,
                    description: event.description || 'No description available',
                    eventType: 'GoogleEvent',
                    allDay: !event.start.dateTime,
                    extendedProps: {
                        googleEventId: event.id,
                        location: event.location || null,
                        organizer: event.organizer?.email || 'Unknown',
                        attendees: event.attendees?.map((attendee) => ({
                            email: attendee.email,
                            displayName: attendee.displayName || attendee.email,
                            responseStatus: attendee.responseStatus || 'pending',
                            organizer: attendee.organizer || false,
                            optional: attendee.optional || false,
                            imageUrl: attendee.imageUrl || null,
                        })) || [],
                        hangoutLink: event.hangoutLink || null,
                        startTime: event.start.dateTime ? moment(event.start.dateTime).format('HH:mm') : null,
                        endTime: event.end.dateTime ? moment(event.end.dateTime).format('HH:mm') : null,
                        startDate: startDate.format('YYYY-MM-DD'),
                        endDate: endDate.format('YYYY-MM-DD'),
                        recurrence: event.recurrence || [],
                        recurringEventId: event.recurringEventId || null,
                        attachments: event.attachments?.map((attachment) => ({
                            fileUrl: attachment.fileUrl,
                            title: attachment.title,
                            mimeType: attachment.mimeType,
                            iconLink: attachment.iconLink,
                            fileId: attachment.fileId,
                        })) || [],
                        conferenceData: event.conferenceData ? {
                            entryPoints: event.conferenceData.entryPoints?.map((entry) => ({
                                entryPointType: entry.entryPointType,
                                uri: entry.uri,
                                label: entry.label,
                                pin: entry.pin || null,
                                regionCode: entry.regionCode || null,
                            })) || [],
                            conferenceSolution: event.conferenceData.conferenceSolution ? {
                                key: event.conferenceData.conferenceSolution.key,
                                name: event.conferenceData.conferenceSolution.name,
                                iconUri: event.conferenceData.conferenceSolution.iconUri,
                            } : null,
                            conferenceId: event.conferenceData.conferenceId || null,
                        } : null,
                        userId,
                    },
                });
            });
        });
    }

    if (Array.isArray(selectedMicrosoftEvents) && selectedMicrosoftEvents.length > 0) {
        selectedMicrosoftEvents.forEach(({ events: userEvents, userId }) => {
            const calendarUser = calendarUsers.find((u) => u.userId === userId);
            const userName = calendarUser?.username || 'Unknown';

            userEvents.forEach((event) => {
                const start = event.start?.dateTime || event.start?.date;
                const end = event.end?.dateTime || event.end?.date;
                if (!start || !end) return;

                if (event.recurrence) {
                    const { pattern, range } = event.recurrence;
                    const startMoment = moment.tz(start, event.start.timeZone || global.config.getTimeZone());
                    const endMoment = moment.tz(end, event.end.timeZone || global.config.getTimeZone());
                    const duration = moment.duration(endMoment.diff(startMoment));
                    const microsoftToRRuleFreqMap = {
                        DAILY: RRule.DAILY,
                        WEEKLY: RRule.WEEKLY,
                        ABSOLUTEMONTHLY: RRule.MONTHLY,
                        RELATIVEMONTHLY: RRule.MONTHLY,
                        ABSOLUTEYEARLY: RRule.YEARLY,
                        RELATIVEYEARLY: RRule.YEARLY,
                    };
                    const windowsToIanaMap = {
                        'Afghanistan Standard Time': 'Asia/Kabul',
                        'Alaskan Standard Time': 'America/Anchorage',
                        'Arab Standard Time': 'Asia/Riyadh',
                        'Arabian Standard Time': 'Asia/Dubai',
                        'Arabic Standard Time': 'Asia/Baghdad',
                        'Argentina Standard Time': 'America/Buenos_Aires',
                        'Atlantic Standard Time': 'America/Halifax',
                        'AUS Central Standard Time': 'Australia/Darwin',
                        'AUS Eastern Standard Time': 'Australia/Sydney',
                        'Azerbaijan Standard Time': 'Asia/Baku',
                        'Azores Standard Time': 'Atlantic/Azores',
                        'Bangladesh Standard Time': 'Asia/Dhaka',
                        'Canada Central Standard Time': 'America/Regina',
                        'Cape Verde Standard Time': 'Atlantic/Cape_Verde',
                        'Caucasus Standard Time': 'Asia/Yerevan',
                        'Cen. Australia Standard Time': 'Australia/Adelaide',
                        'Central America Standard Time': 'America/Guatemala',
                        'Central Asia Standard Time': 'Asia/Almaty',
                        'Central Brazilian Standard Time': 'America/Cuiaba',
                        'Central Europe Standard Time': 'Europe/Budapest',
                        'Central European Standard Time': 'Europe/Warsaw',
                        'Central Pacific Standard Time': 'Pacific/Guadalcanal',
                        'Central Standard Time': 'America/Chicago',
                        'China Standard Time': 'Asia/Shanghai',
                        'Dateline Standard Time': 'Etc/GMT+12',
                        'E. Africa Standard Time': 'Africa/Nairobi',
                        'E. Australia Standard Time': 'Australia/Brisbane',
                        'E. Europe Standard Time': 'Europe/Chisinau',
                        'E. South America Standard Time': 'America/Sao_Paulo',
                        'Eastern Standard Time': 'America/New_York',
                        'Egypt Standard Time': 'Africa/Cairo',
                        'Ekaterinburg Standard Time': 'Asia/Yekaterinburg',
                        'Fiji Standard Time': 'Pacific/Fiji',
                        'FLE Standard Time': 'Europe/Kiev',
                        'Georgian Standard Time': 'Asia/Tbilisi',
                        'GMT Standard Time': 'Europe/London',
                        'Greenland Standard Time': 'America/Godthab',
                        'Greenwich Standard Time': 'Atlantic/Reykjavik',
                        'GTB Standard Time': 'Europe/Bucharest',
                        'Hawaiian Standard Time': 'Pacific/Honolulu',
                        'India Standard Time': 'Asia/Kolkata',
                        'Iran Standard Time': 'Asia/Tehran',
                        'Israel Standard Time': 'Asia/Jerusalem',
                        'Jordan Standard Time': 'Asia/Amman',
                        'Kaliningrad Standard Time': 'Europe/Kaliningrad',
                        'Korea Standard Time': 'Asia/Seoul',
                        'Magadan Standard Time': 'Asia/Magadan',
                        'Mauritius Standard Time': 'Indian/Mauritius',
                        'Middle East Standard Time': 'Asia/Beirut',
                        'Montevideo Standard Time': 'America/Montevideo',
                        'Morocco Standard Time': 'Africa/Casablanca',
                        'Mountain Standard Time': 'America/Denver',
                        'Myanmar Standard Time': 'Asia/Yangon',
                        'N. Central Asia Standard Time': 'Asia/Novosibirsk',
                        'Namibia Standard Time': 'Africa/Windhoek',
                        'Nepal Standard Time': 'Asia/Kathmandu',
                        'New Zealand Standard Time': 'Pacific/Auckland',
                        'Newfoundland Standard Time': 'America/St_Johns',
                        'North Asia East Standard Time': 'Asia/Irkutsk',
                        'North Asia Standard Time': 'Asia/Krasnoyarsk',
                        'Pacific SA Standard Time': 'America/Santiago',
                        'Pacific Standard Time': 'America/Los_Angeles',
                        'Pakistan Standard Time': 'Asia/Karachi',
                        'Paraguay Standard Time': 'America/Asuncion',
                        'Romance Standard Time': 'Europe/Paris',
                        'Russia Time Zone 10': 'Asia/Srednekolymsk',
                        'Russia Time Zone 11': 'Asia/Kamchatka',
                        'Russia Time Zone 3': 'Europe/Samara',
                        'Russian Standard Time': 'Europe/Moscow',
                        'SA Eastern Standard Time': 'America/Cayenne',
                        'SA Pacific Standard Time': 'America/Bogota',
                        'SA Western Standard Time': 'America/La_Paz',
                        'Samoa Standard Time': 'Pacific/Apia',
                        'SE Asia Standard Time': 'Asia/Bangkok',
                        'Singapore Standard Time': 'Asia/Singapore',
                        'South Africa Standard Time': 'Africa/Johannesburg',
                        'Sri Lanka Standard Time': 'Asia/Colombo',
                        'Sudan Standard Time': 'Africa/Khartoum',
                        'Sydney Standard Time': 'Australia/Sydney',
                        'Taipei Standard Time': 'Asia/Taipei',
                        'Tasmania Standard Time': 'Australia/Hobart',
                        'Tokyo Standard Time': 'Asia/Tokyo',
                        'Tonga Standard Time': 'Pacific/Tongatapu',
                        'Turkey Standard Time': 'Europe/Istanbul',
                        'US Eastern Standard Time': 'America/Indianapolis',
                        'US Mountain Standard Time': 'America/Phoenix',
                        'UTC': 'Etc/UTC',
                        'Venezuela Standard Time': 'America/Caracas',
                        'Vladivostok Standard Time': 'Asia/Vladivostok',
                        'W. Australia Standard Time': 'Australia/Perth',
                        'W. Central Africa Standard Time': 'Africa/Lagos',
                        'W. Europe Standard Time': 'Europe/Berlin',
                        'West Asia Standard Time': 'Asia/Tashkent',
                        'West Pacific Standard Time': 'Pacific/Port_Moresby',
                        'Yakutsk Standard Time': 'Asia/Yakutsk'
                    };

                    const timezone = windowsToIanaMap[range.recurrenceTimeZone] || range.recurrenceTimeZone || global.config.getTimeZone();

                    const rule = new RRule({
                        freq: microsoftToRRuleFreqMap[pattern.type.toUpperCase()],
                        interval: pattern.interval || 1,
                        dtstart: startMoment.toDate(),
                        until: range.endDate ? moment.tz(range.endDate, timezone).endOf('day').toDate() : null,
                        count: range.numberOfOccurrences || null,
                    });

                    const dates = rule.all();

                    const validInstanceDates = event.instances
                        ? event.instances.map(instance =>
                            moment.tz(instance.start.dateTime, instance.start.timeZone || global.config.getTimeZone()).startOf('day').toDate()
                        )
                        : [];

                    dates.forEach((date) => {
                        const eventStart = moment.tz(date, event.start.timeZone || global.config.getTimeZone())
                            .set({
                                hour: startMoment.hour(),
                                minute: startMoment.minute(),
                                second: startMoment.second(),
                            })
                            .toDate();
                        const eventEnd = moment.tz(date, event.end.timeZone || global.config.getTimeZone())
                            .set({
                                hour: endMoment.hour(),
                                minute: endMoment.minute(),
                                second: endMoment.second(),
                            })
                            .add(duration)
                            .toDate();

                        const eventStartDay = moment(eventStart).startOf('day').toDate();
                        if (!validInstanceDates.some(validDate => moment(validDate).isSame(eventStartDay, 'day'))) {
                            return;
                        }

                        events.push({
                            // title: `${userName} - ${event.summary || 'Microsoft Calendar Event'}`,
                            title: userId === user._id ? (event.summary || 'Microsoft Calendar Event') : `${userName} - ${event.summary || 'Microsoft Calendar Event'}`,
                            start: eventStart,
                            end: eventEnd,
                            backgroundColor: STATUS_COLORS.MicrosoftEvent.backgroundColor,
                            color: STATUS_COLORS.MicrosoftEvent.color,
                            borderColor: STATUS_COLORS.MicrosoftEvent.borderColor,
                            profileImage: calendarUser?.photoImage ? `/Uploads/lowProfileImage/${calendarUser.photoImage}` : dummyImage,
                            description: event.description || 'No description available',
                            eventType: 'MicrosoftEvent',
                            allDay: event.isAllDay,
                            extendedProps: {
                                microsoftEventId: event.id,
                                etag: event.etag,
                                location: event.location || null,
                                organizer: event.organizer
                                    ? { email: event.organizer.email, displayName: event.organizer.displayName }
                                    : { email: 'Unknown', displayName: 'Unknown' },
                                attendees: event.attendees?.map((attendee) => ({
                                    email: attendee.email,
                                    displayName: attendee.displayName || attendee.email,
                                    responseStatus: attendee.responseStatus || 'pending',
                                    type: attendee.type || 'required',
                                    statusTime: attendee.statusTime || null,
                                    imageUrl: attendee.imageUrl || null,
                                })) || [],
                                teamsLink: null,
                                startTime: moment(eventStart).format('HH:mm'),
                                endTime: moment(eventEnd).format('HH:mm'),
                                startDate: moment(eventStart).format('YYYY-MM-DD'),
                                endDate: moment(eventEnd).format('YYYY-MM-DD'),
                                recurrence: event.recurrence || null,
                                recurringEventId: event.recurringEventId || null,
                                attachments: [],
                                conferenceData: null,
                                userId,
                            },
                        });
                    });
                } else {
                    events.push({
                        title: `${userName} - ${event.summary || 'Microsoft Calendar Event'}`,
                        start: moment.tz(start, event.start.timeZone || global.config.getTimeZone()).toDate(),
                        end: moment.tz(end, event.end.timeZone || global.config.getTimeZone()).toDate(),
                        backgroundColor: STATUS_COLORS.MicrosoftEvent.backgroundColor,
                        color: STATUS_COLORS.MicrosoftEvent.color,
                        borderColor: STATUS_COLORS.MicrosoftEvent.borderColor,
                        profileImage: calendarUser?.photoImage ? `/Uploads/lowProfileImage/${calendarUser.photoImage}` : dummyImage,
                        description: event.description || 'No description available',
                        eventType: 'MicrosoftEvent',
                        allDay: event.isAllDay,
                        extendedProps: {
                            microsoftEventId: event.id,
                            etag: event.etag,
                            location: event.location || null,
                            organizer: event.organizer
                                ? { email: event.organizer.email, displayName: event.organizer.displayName }
                                : { email: 'Unknown', displayName: 'Unknown' },
                            attendees: event.attendees?.map((attendee) => ({
                                email: attendee.email,
                                displayName: attendee.displayName || attendee.email,
                                responseStatus: attendee.responseStatus || 'pending',
                                type: attendee.type || 'required',
                                statusTime: attendee.statusTime || null,
                                imageUrl: attendee.imageUrl || null,
                            })) || [],
                            teamsLink: null,
                            startTime: event.start.dateTime ? moment(event.start.dateTime).format('HH:mm') : null,
                            endTime: event.end.dateTime ? moment(event.end.dateTime).format('HH:mm') : null,
                            startDate: moment(event.start.dateTime || event.start.date).format('YYYY-MM-DD'),
                            endDate: moment(event.end.dateTime || event.end.date || event.start.dateTime || event.start.date).format('YYYY-MM-DD'),
                            recurrence: event.recurrence || null,
                            recurringEventId: event.recurringEventId || null,
                            attachments: [],
                            conferenceData: null,
                            userId,
                        },
                    });
                }
            });
        });
    }

    HOLIDAYS_2025.forEach((holiday) => {
        const holidayDate = holiday.date;
        const holidayKey = `${holidayDate}-${holiday.name}`;
        if (!uniqueHolidays.has(holidayKey)) {
            events.push({
                title: `${holiday.name} (Holiday)`,
                date: holidayDate,
                start: moment.tz(holidayDate, global.config.getTimeZone()).toDate(),
                end: moment.tz(holidayDate, global.config.getTimeZone()).toDate(),
                backgroundColor: STATUS_COLORS.Holiday.backgroundColor,
                color: STATUS_COLORS.Holiday.color,
                borderColor: STATUS_COLORS.Holiday.borderColor,
                profileImage: dummyImage,
                description: holiday.description || "Public Holiday",
                eventType: "Holiday",
                allDay: true,
            });
            uniqueHolidays.add(holidayKey);
        }
    });

    const filteredEvents = events.filter((event) => {
        const matchesTitle = filter
            ? event.title.toLowerCase().includes(filter.toLowerCase())
            : true;
        const matchesCategory = selectedCategories.some(category => {
            const categoryConfig = CATEGORYLIST.find(c => c.name === category);
            return categoryConfig && categoryConfig.eventTypes.includes(event.eventType);
        });
        return matchesTitle && matchesCategory;
    });

    const convertToConfiguredTimeZone = (dateStr) => {
        return moment.tz(dateStr, global.config.getTimeZone()).toDate();
    };

    const convertedEvents = filteredEvents.map(event => ({
        ...event,
        start: convertToConfiguredTimeZone(event.start),
        end: convertToConfiguredTimeZone(event.end),
    }));

    const isHolidayDate = (date) => {
        const dateStr = moment(date).format("YYYY-MM-DD");
        return filteredEvents.some((event) => event.eventType === "Holiday" && (event.date === dateStr || moment(event.start).format("YYYY-MM-DD") === dateStr));
    };

    const debouncedFilterChange = useCallback(
        debounce((value) => {
            setFilter(value);
            // Place your actual filter logic here if needed
        }, 500), // 500ms debounce
        []
    );
    const [filt, setFilt] = useState("");
    const handleFilterChange = (e) => {
        const searchTerm = e.target.value;
        setFilt(searchTerm);
        debouncedFilterChange(searchTerm);
    };

    const getEventTypeLabel = () => {
        if (selectedEvents.length === 0) return "Events";
        const eventType = selectedEvents[0].eventType || "Event";
        // Map eventType to plural form for the title
        const typeMap = {
            Leave: "Time Off Request",
            Event: "Event",
            Holiday: "Holiday",
            Birthday: "Birthday",
            Anniversary: "Anniversary",
        };
        return typeMap[eventType] || "Events";
    };

    const handleSelectSlot = ({ start, end }) => {
        const startDate = moment.tz(start, global.config.getTimeZone());
        const endDate = moment.tz(end, global.config.getTimeZone());
        // const isSameDay = startDate.isSame(endDate, "day");
        const rawEndDate = moment.tz(end, global.config.getTimeZone());
        const adjustedEndDateForComparison = rawEndDate.clone().subtract(1, 'second');
        const isSameDay = startDate.isSame(adjustedEndDateForComparison, "day");
        const adjustedEndDate = isSameDay ? endDate : endDate.subtract(1, "day");

        setDateRange([startDate.toDate(), adjustedEndDateForComparison.toDate()]);
        setDateRangeType(isSameDay ? "single" : "multiple");
        setEventDate(startDate.toDate());

        if (isSameDay) {
            const startHour = startDate.hour();
            const endHour = endDate.hour();

            const startTimeMatch = timeList.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.time_value - startHour);
                const currDiff = Math.abs(curr.time_value - startHour);
                return currDiff < prevDiff ? curr : prev;
            }, timeList[0]);

            const endTimeMatch = timeList.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.time_value - endHour);
                const currDiff = Math.abs(curr.time_value - endHour);
                return currDiff < prevDiff ? curr : prev;
            }, timeList[0]);

            setStartTime(startTimeMatch.time_value);
            setEndTime(endTimeMatch.time_value);
            setEventStartTime(startDate);
            setEventEndTime(endDate);
        } else {
            setStartTime("");
            setEndTime("");
            setEventStartTime("");
            setEventEndTime("");
        }
        setEventName("");
        setEventDescription("");
        setEventLocation("");
        setEventOrganizer(user._id);
        setEventAttendees([]);
        setEventBanner(null);
        setIsVirtual(false);
        setEventMeetingLink("");
        setRepeatType(isSameDay ? "does_not_repeat" : "all_day");
        setEventNameIsValid(false);
        setEventDateIsValid(false);
        setIsSlotSelected(true);
        setCreateEventModalOpen(true);
    };

    const handleOpenCreateEventModal = () => {
        if (!isSubmitLoading) {
            setCreateEventModalOpen(true);
            setDateRange([null, null]);
            setDateRangeType("single");
            setEventDate(null);
            setStartTime("");
            setEndTime("");
            setEventStartTime("");
            setEventEndTime("");
            setStartTimeString("");
            setEndTimeString("");
            // setDateRangeIsValid(false);
            setStartTimeIsValid(false);
            setEndTimeIsValid(false);
            setEventName("");
            setEventDescription("");
            setEventLocation("");
            setEventOrganizer(user._id);
            setEventAttendees([]);
            setEventBanner(null);
            setIsVirtual(false);
            setEventMeetingLink("");
            setRepeatType("does_not_repeat");
            setEventNameIsValid(false);
            setEventDateIsValid(false);
            setEventStartTimeIsValid(false);
            setEventEndTimeIsValid(false);
            setRepeatTypeIsValid(false);
            setOrganizerDropdownOpen(false);
            setRepeatTypeDropdownOpen(false);
        }
    };

    const CustomToolbar = ({ date, onNavigate, onView, view }) => {
        // Format the label to include the year in week view
        const formatLabel = () => {
            if (view === 'week') {
                const startOfWeek = moment(date).startOf('week');
                const endOfWeek = moment(date).endOf('week');
                return `${startOfWeek.format('MMM DD')} – ${endOfWeek.format('DD, YYYY')}`;
            }
            // Default label for other views (month, day)
            return moment(date).format(view === 'month' ? 'MMMM YYYY' : 'MMM DD, YYYY');
        };

        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
                marginBottom: '10px',
            }}>
                {/* Today Button */}
                <button
                    onClick={() => onNavigate('TODAY')}
                    style={{
                        padding: '8px 16px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '20px',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        fontSize: '14px',
                        color: '#333',
                    }}
                >
                    Today
                </button>

                {/* Navigation Arrows and Date Label */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button
                        onClick={() => onNavigate('PREV')}
                        style={{
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: '18px',
                            marginRight: '10px',
                            color: '#666',
                        }}
                    >
                        ←
                    </button>
                    <span style={{ fontSize: '16px', fontWeight: '500', color: '#333' }}>
                        {formatLabel()}
                    </span>
                    <button
                        onClick={() => onNavigate('NEXT')}
                        style={{
                            border: 'none',
                            background: 'none',
                            cursor: 'pointer',
                            fontSize: '18px',
                            marginLeft: '10px',
                            color: '#666',
                        }}
                    >
                        →
                    </button>
                </div>

                {/* View Toggle Buttons */}
                <div style={{ display: 'flex', gap: '5px' }}>
                    <button
                        onClick={() => onView('week')}
                        className={`view-btn ${view === 'week' ? 'active' : ''} rounded-left`}
                        style={{
                            padding: '8px 16px',
                            border: '1px solid #e0e0e0',
                            borderRadius: view === 'week' ? '20px 0 0 20px' : '20px',
                            backgroundColor: view === 'week' ? '#6b7280' : '#fff',
                            color: view === 'week' ? '#fff' : '#333',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            textTransform: 'uppercase',
                        }}
                    >
                        Week
                    </button>
                    <button
                        onClick={() => onView('month')}
                        className={`view-btn ${view === 'month' ? 'active' : ''}`}
                        style={{
                            padding: '8px 16px',
                            border: '1px solid #e0e0e0',
                            borderRadius: view === 'month' ? '0' : '20px',
                            backgroundColor: view === 'month' ? '#6b7280' : '#fff',
                            color: view === 'month' ? '#fff' : '#333',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            textTransform: 'uppercase',
                        }}
                    >
                        Month
                    </button>
                    <button
                        onClick={() => onView('day')}
                        className={`view-btn ${view === 'day' ? 'active' : ''} rounded-right`}
                        style={{
                            padding: '8px 16px',
                            border: '1px solid #e0e0e0',
                            borderRadius: view === 'day' ? '0 20px 20px 0' : '20px',
                            backgroundColor: view === 'day' ? '#6b7280' : '#fff',
                            color: view === 'day' ? '#fff' : '#333',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            textTransform: 'uppercase',
                        }}
                    >
                        Day
                    </button>
                </div>
            </div>
        );
    };

    const isMobileView = () => window.innerWidth <= 768;
    // const CustomDayHeader = ({ date }) => {
    //     const label = isMobileView()
    //         ? moment(date).format("ddd D")
    //         : moment(date).format("dddd D");
    //     return <span>{label}</span>;
    // };

    const CustomDayHeader = ({ date }) => {
        const weekday = moment(date).format("ddd"); // Mon … Sun
        const dayNum = moment(date).format("D");   // 1 – 31

        return (
            <div className="day-header">
                <div className="weekday">{weekday}</div>
                <div className="day-num">{dayNum}</div>
            </div>
        );
    };

    // const CustomMonthHeader = ({ date }) => {
    //     const label = isMobileView()
    //         ? moment(date).format("ddd")
    //         : moment(date).format("dddd");
    //     return <span>{label}</span>;
    // };

    const CustomMonthHeader = ({ date }) => {
        const label = moment(date).format("ddd").toUpperCase();
        return <span>{label}</span>;
    };

    const setWeekStartDay = (startDay) => {
        const day = startDay === "Monday" ? 1 : 0;
        moment.updateLocale("en", {
            week: {
                dow: day,
            },
        });
    };

    setWeekStartDay(appSettings.weekStartDay);

    const handleSelectEvent = (event) => {
        setSelectedEvents(event.extendedProps.allEvents || [event.extendedProps]);
        setClickedDate(new Date(event.start));
        setModalIsOpen(true);
        setExpandedEventIndex(null);
    };

    function formatTimeTo12Hour(timeString) {
        if (!timeString) return 'Invalid Time';

        // Try parsing HH:mm:ss or HH:mm format
        const timeParts = timeString.split(':');

        if (timeParts.length < 2) return 'Invalid Time';

        let hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const ampm = hours >= 12 ? 'pm' : 'am';

        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'

        const formattedMinutes = isNaN(minutes) ? '00' : String(minutes).padStart(2, '0');

        return `${hours}:${formattedMinutes}${ampm}`;
    }

    const toggleCategory = (name) => {
        setSelectedCategories((prev) =>
            prev.includes(name)
                ? prev.filter((item) => item !== name)
                : [...prev, name]
        );
    };

    const handleClickOutsideDropdown = (event) => {
        const refs = {
            userDropdown: userDropdownRef.current,
            createDropdown: createDropdownRef.current,
        };

        // Log any null refs for debugging
        Object.entries(refs).forEach(([key, ref]) => {
            if (!ref) {
                console.warn(`Ref ${key} is null`);
            }
        });

        try {
            if (refs.userDropdown && !refs.userDropdown.contains(event.target)) {
                setIsUserDropdownOpen(false);
            }
            if (refs.createDropdown && !refs.createDropdown.contains(event.target)) {
                setIsOpen(false);
            }
        } catch (err) {
            console.error('Error in handleClickOutsideDropdown:', err);
        }
    };

    useEffect(() => {
        dispatch(setHeaderText("Calendar"));
        if (typeof window === 'undefined' || !document) {
            return;
        }

        document.addEventListener('click', handleClickOutsideDropdown);

        return () => {
            document.removeEventListener('click', handleClickOutsideDropdown);
        };
    }, []);

    if (leavesLoading || eventsLoading || userProfileLoading) {
        return (
            <div className="loading-container" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#f9fafb',
                animation: 'fadeIn 0.5s ease-in'
            }}>
                <ThreeDots
                    height="80"
                    width="80"
                    radius="9"
                    color="#2563eb"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                />
                <p style={{
                    marginTop: '16px',
                    fontSize: '18px',
                    color: '#374151',
                    fontWeight: '500'
                }}>
                </p>
            </div>
        );
    }

    if (leavesError) return <div className="error">Error: {leavesError.message}</div>;
    if (eventsError) return <div className="error">Error: {eventsError.message}</div>;
    if (selectedGoogleEventsError) return <div className="error">Error: {selectedGoogleEventsError}</div>;
    if (selectedMicrosoftEventsError) return <div className="error">Error: {selectedMicrosoftEventsError}</div>;

    return (
        <>
            <div className='user-outer-overview report-top-button eport-top-button-new'>
                <div className='button-inner-report'>
                    <div className="dropdown-container-cal" ref={createDropdownRef}>
                        <button className="dropdown-button-cal" onClick={toggleDropdown}>
                            <span className="icon-export">
                                <img src={PlusIcon} alt="New Event" />
                            </span>
                            Create
                            <span className="icon-export icon-export-arrow">
                                <img src={ArrowIcon} alt="Arrow" />
                            </span>
                        </button>
                        {isOpen && (
                            <div className="dropdown-menu-cal">
                                <div className="dropdown-item-cal"
                                    onClick={() => {
                                        handleOpenCreateEventModal();
                                        setIsOpen(false);
                                    }}
                                >
                                    Event
                                </div>
                                {/* <div className="dropdown-item-cal">Time-off Request</div>
                                <div className="dropdown-item-cal">Birthday</div>
                                <div className="dropdown-item-cal">Anniversary</div> */}
                            </div>
                        )}
                    </div>
                </div>
                <div className="search-sec">
                    <div className="search-container">
                        <input
                            type="text"
                            onChange={handleFilterChange}
                            value={filt}
                            className="search-input"
                            placeholder={global.config.locate(appSettings && appSettings.language, 'Search') || "Search"}
                        />
                    </div>
                </div>
            </div>
            <div className="calender-filter-outer">
                {(user && (user.userType === SUPER_ADMIN || user.userType === ADMIN)) && (
                    <div className="filter-inner invoice-status">
                        <label htmlFor="user">User Visibility</label>
                        <div className="custom-dropdown1" ref={userDropdownRef}>
                            <div className="drop-down-inner">
                                <div
                                    className="selected-options1"
                                    onClick={() => {
                                        if (!isUserDropdownOpen) {
                                            setIsUserLoading(true);
                                            setIsUserDropdownOpen(true);
                                            setTimeout(() => {
                                                setIsUserLoading(false);
                                            }, 0); // Simulate loader duration
                                        } else {
                                            setIsUserDropdownOpen(false);
                                        }
                                    }}
                                >
                                    {isUserLoading ? (
                                        <div className="loader-in-selected-options">
                                            <ThreeDots
                                                height="20"
                                                width="20"
                                                radius="9"
                                                color="#2563eb"
                                                ariaLabel="three-dots-loading"
                                                visible={true}
                                            />
                                        </div>
                                    ) : selectedUsers.length === 0 ? (
                                        <div className="placeholder">Select</div>
                                    ) : (
                                        <div className="selected-option1" key={selectedUsers[0]}>
                                            {selectedUsers.length === calendarUsers.length ? (
                                                `All`
                                            ) : (
                                                <>
                                                    <span>
                                                        {calendarUsers.find((user) => user.userId.toString() === selectedUsers[0].toString())?.username || 'Select User'}
                                                    </span>
                                                    {selectedUsers.length > 1 && selectedUsers.length !== calendarUsers.length && (
                                                        <div className="selected-option-count">
                                                            {selectedUsers.length - 1}+
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {isUserDropdownOpen && (
                                    <div className="dropdown-list1">
                                        <input
                                            type="text"
                                            placeholder="Search users"
                                            value={googleMicrosoftUserSearchTerm}
                                            onChange={(e) => setGoogleMicrosoftUserSearchTerm(e.target.value)}
                                            className="search-bar"
                                        />
                                        {calendarUsers
                                            .filter((user) =>
                                                user.username.toLowerCase().includes(googleMicrosoftUserSearchTerm.toLowerCase())
                                            )
                                            .length > 0 && (
                                                <>
                                                    {googleMicrosoftUserSearchTerm === '' && (
                                                        <label className="checkbox-label1" key="selectAll">
                                                            <input
                                                                type="checkbox"
                                                                checked={selectAllUsers}
                                                                onChange={(e) => {
                                                                    if (e.target.checked) {
                                                                        setSelectedUsers(calendarUsers.map((user) => user.userId));
                                                                    } else {
                                                                        setSelectedUsers([]);
                                                                    }
                                                                }}
                                                            />
                                                            All Users
                                                        </label>
                                                    )}
                                                    {calendarUsers
                                                        .filter((user) =>
                                                            user.username.toLowerCase().includes(googleMicrosoftUserSearchTerm.toLowerCase())
                                                        )
                                                        .sort((a, b) => a.username.localeCompare(b.username))
                                                        .map((user) => (
                                                            <label className="checkbox-label1" key={user.userId}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectedUsers.includes(user.userId)}
                                                                    onChange={() => {
                                                                        setSelectedUsers(
                                                                            selectedUsers.includes(user.userId)
                                                                                ? selectedUsers.filter((id) => id !== user.userId)
                                                                                : [...selectedUsers, user.userId]
                                                                        );
                                                                    }}
                                                                />
                                                                {user.username}
                                                            </label>
                                                        ))}
                                                </>
                                            )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}


                <div className="filter-inner filter-sec-category-calendar">
                    <div className="category-section">
                        <label>Categories</label>
                        <div className="category-box">
                            {CATEGORYLIST.map(({ name, color }) => {
                                const isChecked = selectedCategories.includes(name);
                                return (
                                    <label
                                        key={name}
                                        className="category-pill"

                                    >
                                        <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={() => toggleCategory(name)}
                                            style={{ backgroundColor: isChecked ? color : '#f1f1f1' }}
                                        />
                                        <span className="category-label">{name}</span>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                </div>


            </div>
            <div className="calendar-container p-4">
                <BigCalendar
                    localizer={localizer}
                    events={groupEventsByKey(filteredEvents)}
                    startAccessor="start"
                    endAccessor="end"
                    defaultView="month"
                    views={["month", "week", "day"]}
                    step={60}
                    timeslots={1}
                    selectable
                    onSelectSlot={handleSelectSlot}
                    onSelectEvent={handleSelectEvent}
                    // onNavigate={handleNavigate}
                    onView={(newView) => setView(newView)}
                    view={view}
                    components={{
                        toolbar: CustomToolbar,
                        timeSlotsWrapper: CustomTimeSlotsWrapper,
                        week: {
                            header: CustomDayHeader,
                        },
                        month: {
                            header: CustomMonthHeader,
                        },
                    }}
                    formats={{
                        timeGutterFormat: (date, culture, localizer) =>
                            moment(date).format("hh:mm A"),
                    }}
                    style={{ minHeight: "785px", height: "max-content" }}
                    // min={moment('2024-01-01').hour(0).minute(0).toDate()}
                    // max={moment('2026-12-31').hour(23).minute(59).toDate()}
                    eventPropGetter={(event) => {
                        // const hex = event.textColor || "#FF5733";
                        // const rgbaColor = hexToRgba(hex, 0.6); // adjust 0.3 for different opacity
                        return {
                            style: {
                                backgroundColor: event.backgroundColor,
                                color: event.textColor,
                                borderRadius: "4px",
                                padding: "6px 16px 8px 6px",
                                borderLeft: `4px solid ${event.borderColor}`,
                                transition: "transform 0.2s",
                                fontWeight: "600",
                            },
                        };
                    }}
                    dayPropGetter={(date) => ({
                        className: isHolidayDate(date) ? "holiday-date" : "",
                    })}
                />
                <ViewCalendarEventModal
                    modalIsOpen={modalIsOpen}
                    setModalIsOpen={setModalIsOpen}
                    selectedEvents={selectedEvents}
                    setSelectedEvents={setSelectedEvents}
                    expandedEventIndex={expandedEventIndex}
                    setExpandedEventIndex={setExpandedEventIndex}
                    isSubmitLoading={isSubmitLoading}
                    setIsSubmitLoading={setIsSubmitLoading}
                    user={user}
                    getEventTypeLabel={getEventTypeLabel}
                    dummyImage={dummyImage}
                    STATUS_COLORS={STATUS_COLORS}
                    selectedEventForEdit={selectedEventForEdit}
                    setSelectedEventForEdit={setSelectedEventForEdit}
                    eventName={eventName}
                    setEventName={setEventName}
                    eventDate={eventDate}
                    setEventDate={setEventDate}
                    eventDescription={eventDescription}
                    setEventDescription={setEventDescription}
                    eventLocation={eventLocation}
                    setEventLocation={setEventLocation}
                    eventOrganizer={eventOrganizer}
                    setEventOrganizer={setEventOrganizer}
                    externalAttendees={externalAttendees}
                    setExternalAttendees={setExternalAttendees}
                    eventBannerFile={eventBannerFile}
                    setEventBannerFile={setEventBannerFile}
                    repeatType={repeatType}
                    setRepeatType={setRepeatType}
                    eventStartTime={eventStartTime}
                    setEventStartTime={setEventStartTime}
                    eventEndTime={eventEndTime}
                    setEventEndTime={setEventEndTime}
                    formatTimeTo12Hour={formatTimeTo12Hour}
                    userProfiles={userProfiles}
                    userProfileLoading={userProfileLoading}
                    refetchLeaves={refetchLeaves}
                    refetchEvents={refetchEvents}
                    refetchSelectedGoogleEvents={refetchSelectedGoogleEvents}
                    refetchSelectedMicrosoftEvents={refetchSelectedMicrosoftEvents}
                />
                <CreateEventModal
                    createEventModalOpen={createEventModalOpen}
                    setCreateEventModalOpen={setCreateEventModalOpen}
                    isSubmitLoading={isSubmitLoading}
                    setIsSubmitLoading={setIsSubmitLoading}
                    isGoogleSyncVisible={isGoogleSyncVisible}
                    isMicrosoftSyncVisible={isMicrosoftSyncVisible}
                    setIsMicrosoftTokenInvalidModalOpen={setIsMicrosoftTokenInvalidModalOpen}
                    eventName={eventName}
                    setEventName={setEventName}
                    eventNameIsValid={eventNameIsValid}
                    setEventNameIsValid={setEventNameIsValid}
                    repeatType={repeatType}
                    setRepeatType={setRepeatType}
                    repeatTypeIsValid={repeatTypeIsValid}
                    setRepeatTypeIsValid={setRepeatTypeIsValid}
                    repeatTypeDropdownOpen={repeatTypeDropdownOpen}
                    setRepeatTypeDropdownOpen={setRepeatTypeDropdownOpen}
                    eventDate={eventDate}
                    setEventDate={setEventDate}
                    eventDateIsValid={eventDateIsValid}
                    setEventDateIsValid={setEventDateIsValid}
                    // dateRangeType={dateRangeType}
                    // setDateRangeType={setDateRangeType}
                    setDateRange={setDateRange}
                    appSettings={appSettings}
                    isSlotSelected={isSlotSelected}
                    setIsSlotSelected={setIsSlotSelected}
                    eventStartTime={eventStartTime}
                    setEventStartTime={setEventStartTime}
                    startTimeIsValid={startTimeIsValid}
                    setStartTimeIsValid={setStartTimeIsValid}
                    eventStartTimeIsValid={eventStartTimeIsValid}
                    setEventStartTimeIsValid={setEventStartTimeIsValid}
                    eventEndTime={eventEndTime}
                    setEventEndTime={setEventEndTime}
                    endTimeIsValid={endTimeIsValid}
                    setStartTime={setStartTime}
                    setEndTime={setEndTime}
                    setEndTimeIsValid={setEndTimeIsValid}
                    eventEndTimeIsValid={eventEndTimeIsValid}
                    setEventEndTimeIsValid={setEventEndTimeIsValid}
                    eventDescription={eventDescription}
                    setEventDescription={setEventDescription}
                    eventLocation={eventLocation}
                    setEventLocation={setEventLocation}
                    eventBannerFile={eventBannerFile}
                    setEventBanner={setEventBanner}
                    setDateRangeIsValid={setDateRangeIsValid}
                    endTimeString={endTimeString}
                    setEndTimeString={setEndTimeString}
                    startTimeString={startTimeString}
                    setStartTimeString={setStartTimeString}
                    user={user}
                    eventOrganizer={eventOrganizer}
                    setEventOrganizer={setEventOrganizer}
                    organizerDropdownOpen={organizerDropdownOpen}
                    setOrganizerDropdownOpen={setOrganizerDropdownOpen}
                    userProfiles={userProfiles}
                    userProfileLoading={userProfileLoading}
                    eventAttendees={eventAttendees}
                    setEventAttendees={setEventAttendees}
                    externalAttendees={externalAttendees}
                    setExternalAttendees={setExternalAttendees}
                    isVirtual={isVirtual}
                    setIsVirtual={setIsVirtual}
                    eventMeetingLink={eventMeetingLink}
                    setEventMeetingLink={setEventMeetingLink}
                    reminderMethod={reminderMethod}
                    setReminderMethod={setReminderMethod}
                    reminderMethodDropdownOpen={reminderMethodDropdownOpen}
                    setReminderMethodDropdownOpen={setReminderMethodDropdownOpen}
                    reminderMinutes={reminderMinutes}
                    setReminderMinutes={setReminderMinutes}
                    reminderMinutesIsValid={reminderMinutesIsValid}
                    setReminderMinutesIsValid={setReminderMinutesIsValid}
                    token={token}
                    setIsMicrosoftTokenChecking={setIsMicrosoftTokenChecking}
                    checkMicrosoftTokenValidity={checkMicrosoftTokenValidity}
                    checkMicrosoftCalendarEnabledStatus={checkMicrosoftCalendarEnabledStatus}
                    refetchEvents={refetchEvents}
                    refetchSelectedGoogleEvents={refetchSelectedGoogleEvents}
                    refetchSelectedMicrosoftEvents={refetchSelectedMicrosoftEvents}
                />
                <GoogleTokenInvalidModal
                    isGoogleTokenInvalidModalOpen={isGoogleTokenInvalidModalOpen}
                    setIsGoogleTokenInvalidModalOpen={setIsGoogleTokenInvalidModalOpen}
                    user={user}
                    isGoogleTokenChecking={isGoogleTokenChecking}
                />
                <MicrosoftTokenInvalidModal
                    isMicrosoftTokenInvalidModalOpen={isMicrosoftTokenInvalidModalOpen}
                    setIsMicrosoftTokenInvalidModalOpen={setIsMicrosoftTokenInvalidModalOpen}
                    user={user}
                    isMicrosoftTokenChecking={isMicrosoftTokenChecking}
                />
            </div>
        </>
    );
};

export default Calender;